import React, { useEffect, useState } from 'react'
import Modal from 'shared/components/Modal'
import Button from 'shared/components/Button'
import { MdCheck } from 'react-icons/md'

import { FormControl, FormControlLabel, RadioGroup } from '@material-ui/core'
import { colors } from 'shared/styles/colors'

import { Container, RadioContainer, StyledRadio, Title } from './styles'
import Text from 'shared/components/Text'
import { IFindActiveTag } from 'modules/pedagio/domain/usecases/FindActiveTag'
import { IsaveTag } from 'modules/pedagio/domain/usecases/SaveTag'
import LoadingBackdrop from 'shared/components/LoadingBackdrop'

type TProps = {
  cpfMotorista: string
  operadoras: string[]
  findActiveTag: IFindActiveTag
  saveTag: IsaveTag
  openModal: boolean
  setOpenModal: (value: boolean) => void
  onConfirm: () => void
}

const ModalTagPedagio: React.FC<TProps> = ({
  cpfMotorista,
  operadoras,
  findActiveTag,
  saveTag,
  openModal,
  setOpenModal,
  onConfirm,
}) => {
  const [tagSelecionada, setTagSelecionada] = useState('')
  const [loading, setLoading] = useState(false)

  const handleFindActiveTag = async () => {
    try {
      setLoading(true)
      const response = await findActiveTag.execute(cpfMotorista)
      setLoading(false)
      setTagSelecionada(response)
    } catch (error) {
      setLoading(false)
      setTagSelecionada(null)
    }
  }

  const handleSaveTag = async () => {
    try {
      setLoading(true)
      await saveTag.execute({
        cpf_motorista: cpfMotorista,
        tag_pedagio: tagSelecionada,
      })
      setLoading(false)
      setOpenModal(false)
      onConfirm()
    } catch (error) {
      setLoading(false)
      setOpenModal(false)
      onConfirm()
    }
  }

  useEffect(() => {
    if (cpfMotorista) handleFindActiveTag()
  }, [cpfMotorista])

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTagSelecionada(event.target.value)
  }

  return (
    <Modal
      openModal={openModal}
      showCloseButton={false}
      size="unset"
      onCloseModal={() => {
        setOpenModal(false)
      }}
    >
      {loading && <LoadingBackdrop open={loading} color={colors.green} />}

      <Container>
        <Title>Confirme a sua TAG de pedágio!</Title>
        <FormControl component="fieldset">
          <RadioGroup value={tagSelecionada} onChange={handleChange}>
            {operadoras.map(item => (
              <RadioContainer key={item}>
                <FormControlLabel
                  value={item}
                  control={
                    <StyledRadio value={item} style={{ color: colors?.blue }} />
                  }
                  label={
                    <Text weight="700" color={colors?.grayDark}>
                      {item}
                    </Text>
                  }
                />
              </RadioContainer>
            ))}
          </RadioGroup>
        </FormControl>
        <Button
          onClick={() => {
            handleSaveTag()
          }}
          color={colors.orange}
          style={{ width: 250 }}
        >
          <MdCheck />
          Concluir
        </Button>
      </Container>
    </Modal>
  )
}

export default ModalTagPedagio
